import { Paper, SxProps, Theme, Typography, styled } from '@mui/material';
import { Link } from 'react-router';

type SettingsSurface = { clickable?: boolean };

export const SettingsLink = styled(Link)({
  textDecoration: 'none',
  color: 'inherit',
});

export const SettingsGroupTitle = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  color: theme.palette.text.secondary,
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  marginTop: `${theme.spacing(2)} !important`,
  marginBottom: `${theme.spacing(0.5)} !important`,
}));

export const BaseSettingsPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  boxShadow: '0px -1px 0px rgba(0, 0, 0, 0.12) inset',
  borderRadius: theme.shape.borderRadius,
  border: '1px solid rgba(0, 0, 0, 0.1)',
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
}));

export const SettingsPaper = styled(BaseSettingsPaper, {
  shouldForwardProp: (prop) => prop !== 'clickable',
})<SettingsSurface>(({ theme, clickable }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2),

  ...(clickable && {
    cursor: 'pointer',
    transition: 'background-color .2s, box-shadow .2s',

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      boxShadow: theme.shadows[4],
    },
  }),
}));

export const SettingsColumnPaper = styled(BaseSettingsPaper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  padding: theme.spacing(1, 2),
}));

export const SettingsPaperTitle = styled(Typography)({
  flexGrow: 1,
});

export const settingsIconSx: SxProps<Theme> = {
  width: 24,
  height: 24,
  color: 'action.active',
  flexShrink: 0,
};

export const settingsStartIconSx: SxProps<Theme> = {
  ...settingsIconSx,
  mr: 4,
};
